<!--
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-08-16 08:53:31
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-04 10:08:08
-->
<template>
  <div class="container">
    <div class="left">
      <span
        style="
          font-size: 30px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 600;
          color: #000000;
        "
        >账户信息</span
      >
      <span
        @click="checkOption('个人信息')"
        :class="{ active: option == '个人信息' || option == '修改信息' }"
        >个人信息</span
      >
      <span
        @click="checkOption('安全中心')"
        :class="{ active: option == '安全中心' }"
        >安全中心</span
      >
      <span
        @click="checkOption('消息中心')"
        :class="{ active: option == '消息中心' }"
        >消息中心</span
      >
      <span
        style="
          margin-top: 18px;
          font-size: 30px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 600;
          color: #000000;
        "
        >项目信息</span
      >
      <span
        @click="checkOption('我报名的项目')"
        :class="{ active: option == '我报名的项目' }"
        >我报名的项目</span
      >
      <span
        @click="checkOption('我竞价的项目')"
        :class="{ active: option == '我竞价的项目' }"
        >我竞价的项目</span
      >
      <span
        @click="checkOption('我中标的项目')"
        :class="{ active: option == '我中标的项目' }"
        >我中标的项目</span
      >
    </div>
    <div class="right">
      <GRXX v-if="option == '个人信息'" />
      <XGXX v-if="option == '修改信息'" />
      <AQZX v-if="option == '安全中心'" />
      <XXZX v-if="option == '消息中心'" />
      <WBMDXM v-if="option == '我报名的项目'" />
      <WJJDXM v-if="option == '我竞价的项目'" />
      <WZBDXM v-if="option == '我中标的项目'" />
    </div>
  </div>
</template>

<script>
import GRXX from '@/components/personage/info.vue'
import XGXX from '@/components/personage/updataInfo.vue'
import AQZX from '@/components/personage/safety.vue'
import XXZX from '@/components/personage/information.vue'
import WBMDXM from '@/components/personage/apply.vue'
import WJJDXM from '@/components/personage/bidding.vue'
import WZBDXM from '@/components/personage/winBidding.vue'
export default {
  created () {
    if (!localStorage.getItem('token')) {
      this.$message.error('请先登录')
      if (cityDetail.homeShowLogin) {
        this.$router.push('/')
      } else {
        this.$router.push('/login')
      }
    }
  },
  data () {
    return {
      option: '个人信息',
    }
  },
  methods: {
    checkOption (check) {
      this.option = check
    },
  },
  components: {
    GRXX,
    XGXX,
    AQZX,
    XXZX,
    WBMDXM,
    WJJDXM,
    WZBDXM,
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.container {
  width: 1864px;
  margin: 0 auto;
  display: flex;
}

.left {
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  width: 300px;
  box-shadow: 0px 0px 25px 4px rgba(90, 90, 90, 0.12);
}

.left > span {
  font-size: 26px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #616161;
  margin-bottom: 16px;
  cursor: pointer;
}

.active {
  color: #6681ea !important;
}

.right {
  margin-left: 30px;
  flex: 1;
}

/* .left>div {
        zoom: 1.2;
    }

    .right>div {
        zoom: 1.2;
    } */
</style>
